import { Component, Inject } from '@angular/core';
import { PopupContentType, PopupCustomProps } from './connection-popup.types';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-connection-popup',
  templateUrl: './connection-popup.component.html',
  styleUrls: []
})
export class ConnectionPopupComponent {
  PopupContentType = PopupContentType;
  constructor(
    @Inject(MAT_DIALOG_DATA) public popupCustomProps: PopupCustomProps,
    private dialogRef: MatDialogRef<ConnectionPopupComponent>
  ) {}

  onOkClick(): void {
    this.dialogRef.close();
  }
}
